const OntologyVersionPage = () => import('@/pages/ontology/versions/OntologyVersions.vue')

const OntologyHome = () => import('@/pages/ontology/OntologyHome.vue')
const OntologyOverview = () => import('@/pages/ontology/overview/OntologyOverview.vue')
const TopicEditPage = () => import('@/pages/ontology/topics/TopicEditPage.vue')
const FactorEditPage = () => import('@/pages/ontology/factors/FactorEditPage.vue')
const NewTerm = () => import('@/pages/ontology/terms/NewTerm.vue')

const NLPCheckPage = () => import('@/pages/ontology/nlp_check/NLPcheck.vue')

const ONTOLOGY_VERSION_ROUTES = [
	{
		path: 'overview',
		component: OntologyOverview,
		props: (route) => {
			return { topicId: Number(route.query.topic_id), factorId: Number(route.query.factor_id), termId: Number(route.query.term_id) }
		}
	},
	{
		path: 'term',
		component: NewTerm,
		props: (route) => {
			return { factorId: Number(route.query.factor_id), topicId: Number(route.query.topic_id) }
		}
	},
	{
		path: 'topic',
		component: TopicEditPage
	},
	{
		path: 'topic/:id',
		component: TopicEditPage,
		props: (route) => {
			return { topicId: Number(route.params?.id) }
		}
	},
	{
		path: 'factor',
		component: FactorEditPage,
		props: (route) => {
			return { topicId: Number(route.query.topic_id) }
		}
	},
	{
		path: 'factor/:id',
		component: FactorEditPage,
		props: (route) => {
			return { factorId: Number(route.params?.id), topicId: Number(route.query.topic_id) }
		}
	}
]

export const ONTOLOGY_ROUTES = [
	{
		path: '/ontology_versions/:version_id',
		component: OntologyHome,
		props: (route) => ({
			versionId: Number(route.params.version_id)
		}),
		children: ONTOLOGY_VERSION_ROUTES
	},
	{
		path: '/ontology_versions',
		component: OntologyVersionPage
	},
	{
		path: '/ontology_nlp_check',
		component: NLPCheckPage
	}
]
